import { IApplicationState } from '../../types/redux';

export function getObjectInfo(state: IApplicationState) {
  return state.objectInfo;
}
